/**
 * @fileoverview gRPC-Web generated client stub for questionbank
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: questionbank/questionbank.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.questionbank = require('./questionbank_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.questionbank.QuestionBankServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.questionbank.QuestionBankServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.CreateQuestionBankModuleRequest,
 *   !proto.questionbank.QuestionBankModule>}
 */
const methodDescriptor_QuestionBankService_CreateQuestionBankModule = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/CreateQuestionBankModule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.CreateQuestionBankModuleRequest,
  proto.questionbank.QuestionBankModule,
  /**
   * @param {!proto.questionbank.CreateQuestionBankModuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankModule.deserializeBinary
);


/**
 * @param {!proto.questionbank.CreateQuestionBankModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankModule)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankModule>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.createQuestionBankModule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankModule,
      callback);
};


/**
 * @param {!proto.questionbank.CreateQuestionBankModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankModule>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.createQuestionBankModule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankModule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.ListQuestionBankModulesRequest,
 *   !proto.questionbank.ListQuestionBankModulesResponse>}
 */
const methodDescriptor_QuestionBankService_ListQuestionBankModules = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/ListQuestionBankModules',
  grpc.web.MethodType.UNARY,
  proto.questionbank.ListQuestionBankModulesRequest,
  proto.questionbank.ListQuestionBankModulesResponse,
  /**
   * @param {!proto.questionbank.ListQuestionBankModulesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.ListQuestionBankModulesResponse.deserializeBinary
);


/**
 * @param {!proto.questionbank.ListQuestionBankModulesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.ListQuestionBankModulesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.ListQuestionBankModulesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.listQuestionBankModules =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionBankModules',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionBankModules,
      callback);
};


/**
 * @param {!proto.questionbank.ListQuestionBankModulesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.ListQuestionBankModulesResponse>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.listQuestionBankModules =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionBankModules',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionBankModules);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.UpdateQuestionBankModuleRequest,
 *   !proto.questionbank.QuestionBankModule>}
 */
const methodDescriptor_QuestionBankService_UpdateQuestionBankModule = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/UpdateQuestionBankModule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.UpdateQuestionBankModuleRequest,
  proto.questionbank.QuestionBankModule,
  /**
   * @param {!proto.questionbank.UpdateQuestionBankModuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankModule.deserializeBinary
);


/**
 * @param {!proto.questionbank.UpdateQuestionBankModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankModule)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankModule>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.updateQuestionBankModule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/UpdateQuestionBankModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_UpdateQuestionBankModule,
      callback);
};


/**
 * @param {!proto.questionbank.UpdateQuestionBankModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankModule>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.updateQuestionBankModule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/UpdateQuestionBankModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_UpdateQuestionBankModule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.DeleteQuestionBankModuleRequest,
 *   !proto.questionbank.Empty>}
 */
const methodDescriptor_QuestionBankService_DeleteQuestionBankModule = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/DeleteQuestionBankModule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.DeleteQuestionBankModuleRequest,
  proto.questionbank.Empty,
  /**
   * @param {!proto.questionbank.DeleteQuestionBankModuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Empty.deserializeBinary
);


/**
 * @param {!proto.questionbank.DeleteQuestionBankModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.deleteQuestionBankModule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankModule,
      callback);
};


/**
 * @param {!proto.questionbank.DeleteQuestionBankModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Empty>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.deleteQuestionBankModule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankModule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.CreateQuestionBankQuestionRequest,
 *   !proto.questionbank.QuestionBankQuestion>}
 */
const methodDescriptor_QuestionBankService_CreateQuestionBankQuestion = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/CreateQuestionBankQuestion',
  grpc.web.MethodType.UNARY,
  proto.questionbank.CreateQuestionBankQuestionRequest,
  proto.questionbank.QuestionBankQuestion,
  /**
   * @param {!proto.questionbank.CreateQuestionBankQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankQuestion.deserializeBinary
);


/**
 * @param {!proto.questionbank.CreateQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankQuestion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankQuestion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.createQuestionBankQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankQuestion,
      callback);
};


/**
 * @param {!proto.questionbank.CreateQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankQuestion>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.createQuestionBankQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.GetQuestionBankQuestionRequest,
 *   !proto.questionbank.QuestionBankQuestion>}
 */
const methodDescriptor_QuestionBankService_GetQuestionBankQuestion = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/GetQuestionBankQuestion',
  grpc.web.MethodType.UNARY,
  proto.questionbank.GetQuestionBankQuestionRequest,
  proto.questionbank.QuestionBankQuestion,
  /**
   * @param {!proto.questionbank.GetQuestionBankQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankQuestion.deserializeBinary
);


/**
 * @param {!proto.questionbank.GetQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankQuestion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankQuestion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.getQuestionBankQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/GetQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_GetQuestionBankQuestion,
      callback);
};


/**
 * @param {!proto.questionbank.GetQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankQuestion>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.getQuestionBankQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/GetQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_GetQuestionBankQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.ListQuestionBankQuestionsByModuleRequest,
 *   !proto.questionbank.ListQuestionBankQuestionsByModuleResponse>}
 */
const methodDescriptor_QuestionBankService_ListQuestionBankQuestionsByModule = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/ListQuestionBankQuestionsByModule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.ListQuestionBankQuestionsByModuleRequest,
  proto.questionbank.ListQuestionBankQuestionsByModuleResponse,
  /**
   * @param {!proto.questionbank.ListQuestionBankQuestionsByModuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.ListQuestionBankQuestionsByModuleResponse.deserializeBinary
);


/**
 * @param {!proto.questionbank.ListQuestionBankQuestionsByModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.ListQuestionBankQuestionsByModuleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.ListQuestionBankQuestionsByModuleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.listQuestionBankQuestionsByModule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionBankQuestionsByModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionBankQuestionsByModule,
      callback);
};


/**
 * @param {!proto.questionbank.ListQuestionBankQuestionsByModuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.ListQuestionBankQuestionsByModuleResponse>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.listQuestionBankQuestionsByModule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionBankQuestionsByModule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionBankQuestionsByModule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.UpdateQuestionBankQuestionRequest,
 *   !proto.questionbank.QuestionBankQuestion>}
 */
const methodDescriptor_QuestionBankService_UpdateQuestionBankQuestion = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/UpdateQuestionBankQuestion',
  grpc.web.MethodType.UNARY,
  proto.questionbank.UpdateQuestionBankQuestionRequest,
  proto.questionbank.QuestionBankQuestion,
  /**
   * @param {!proto.questionbank.UpdateQuestionBankQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankQuestion.deserializeBinary
);


/**
 * @param {!proto.questionbank.UpdateQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankQuestion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankQuestion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.updateQuestionBankQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/UpdateQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_UpdateQuestionBankQuestion,
      callback);
};


/**
 * @param {!proto.questionbank.UpdateQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankQuestion>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.updateQuestionBankQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/UpdateQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_UpdateQuestionBankQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.DeleteQuestionBankQuestionRequest,
 *   !proto.questionbank.Empty>}
 */
const methodDescriptor_QuestionBankService_DeleteQuestionBankQuestion = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/DeleteQuestionBankQuestion',
  grpc.web.MethodType.UNARY,
  proto.questionbank.DeleteQuestionBankQuestionRequest,
  proto.questionbank.Empty,
  /**
   * @param {!proto.questionbank.DeleteQuestionBankQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Empty.deserializeBinary
);


/**
 * @param {!proto.questionbank.DeleteQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.deleteQuestionBankQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankQuestion,
      callback);
};


/**
 * @param {!proto.questionbank.DeleteQuestionBankQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Empty>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.deleteQuestionBankQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankQuestion',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.CreateQuestionBankOptionRequest,
 *   !proto.questionbank.QuestionBankOption>}
 */
const methodDescriptor_QuestionBankService_CreateQuestionBankOption = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/CreateQuestionBankOption',
  grpc.web.MethodType.UNARY,
  proto.questionbank.CreateQuestionBankOptionRequest,
  proto.questionbank.QuestionBankOption,
  /**
   * @param {!proto.questionbank.CreateQuestionBankOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankOption.deserializeBinary
);


/**
 * @param {!proto.questionbank.CreateQuestionBankOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankOption)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankOption>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.createQuestionBankOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankOption',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankOption,
      callback);
};


/**
 * @param {!proto.questionbank.CreateQuestionBankOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankOption>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.createQuestionBankOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankOption',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.UpdateQuestionBankOptionRequest,
 *   !proto.questionbank.QuestionBankOption>}
 */
const methodDescriptor_QuestionBankService_UpdateQuestionBankOption = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/UpdateQuestionBankOption',
  grpc.web.MethodType.UNARY,
  proto.questionbank.UpdateQuestionBankOptionRequest,
  proto.questionbank.QuestionBankOption,
  /**
   * @param {!proto.questionbank.UpdateQuestionBankOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankOption.deserializeBinary
);


/**
 * @param {!proto.questionbank.UpdateQuestionBankOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankOption)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankOption>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.updateQuestionBankOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/UpdateQuestionBankOption',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_UpdateQuestionBankOption,
      callback);
};


/**
 * @param {!proto.questionbank.UpdateQuestionBankOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankOption>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.updateQuestionBankOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/UpdateQuestionBankOption',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_UpdateQuestionBankOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.DeleteQuestionBankOptionRequest,
 *   !proto.questionbank.Empty>}
 */
const methodDescriptor_QuestionBankService_DeleteQuestionBankOption = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/DeleteQuestionBankOption',
  grpc.web.MethodType.UNARY,
  proto.questionbank.DeleteQuestionBankOptionRequest,
  proto.questionbank.Empty,
  /**
   * @param {!proto.questionbank.DeleteQuestionBankOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Empty.deserializeBinary
);


/**
 * @param {!proto.questionbank.DeleteQuestionBankOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.deleteQuestionBankOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankOption',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankOption,
      callback);
};


/**
 * @param {!proto.questionbank.DeleteQuestionBankOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Empty>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.deleteQuestionBankOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankOption',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.CreateQuestionBankGatingRuleRequest,
 *   !proto.questionbank.QuestionBankGatingRule>}
 */
const methodDescriptor_QuestionBankService_CreateQuestionBankGatingRule = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/CreateQuestionBankGatingRule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.CreateQuestionBankGatingRuleRequest,
  proto.questionbank.QuestionBankGatingRule,
  /**
   * @param {!proto.questionbank.CreateQuestionBankGatingRuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.QuestionBankGatingRule.deserializeBinary
);


/**
 * @param {!proto.questionbank.CreateQuestionBankGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.QuestionBankGatingRule)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.QuestionBankGatingRule>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.createQuestionBankGatingRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankGatingRule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankGatingRule,
      callback);
};


/**
 * @param {!proto.questionbank.CreateQuestionBankGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.QuestionBankGatingRule>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.createQuestionBankGatingRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/CreateQuestionBankGatingRule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_CreateQuestionBankGatingRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.DeleteQuestionBankGatingRuleRequest,
 *   !proto.questionbank.Empty>}
 */
const methodDescriptor_QuestionBankService_DeleteQuestionBankGatingRule = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/DeleteQuestionBankGatingRule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.DeleteQuestionBankGatingRuleRequest,
  proto.questionbank.Empty,
  /**
   * @param {!proto.questionbank.DeleteQuestionBankGatingRuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Empty.deserializeBinary
);


/**
 * @param {!proto.questionbank.DeleteQuestionBankGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.deleteQuestionBankGatingRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankGatingRule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankGatingRule,
      callback);
};


/**
 * @param {!proto.questionbank.DeleteQuestionBankGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Empty>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.deleteQuestionBankGatingRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/DeleteQuestionBankGatingRule',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_DeleteQuestionBankGatingRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.ListQuestionnaireTemplatesRequest,
 *   !proto.questionbank.ListQuestionnaireTemplatesResponse>}
 */
const methodDescriptor_QuestionBankService_ListQuestionnaireTemplates = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/ListQuestionnaireTemplates',
  grpc.web.MethodType.UNARY,
  proto.questionbank.ListQuestionnaireTemplatesRequest,
  proto.questionbank.ListQuestionnaireTemplatesResponse,
  /**
   * @param {!proto.questionbank.ListQuestionnaireTemplatesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.ListQuestionnaireTemplatesResponse.deserializeBinary
);


/**
 * @param {!proto.questionbank.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.ListQuestionnaireTemplatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.ListQuestionnaireTemplatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.listQuestionnaireTemplates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionnaireTemplates,
      callback);
};


/**
 * @param {!proto.questionbank.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.ListQuestionnaireTemplatesResponse>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.listQuestionnaireTemplates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionnaireTemplates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.ListQuestionnaireTemplateSectionsRequest,
 *   !proto.questionbank.ListQuestionnaireTemplateSectionsResponse>}
 */
const methodDescriptor_QuestionBankService_ListQuestionnaireTemplateSections = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/ListQuestionnaireTemplateSections',
  grpc.web.MethodType.UNARY,
  proto.questionbank.ListQuestionnaireTemplateSectionsRequest,
  proto.questionbank.ListQuestionnaireTemplateSectionsResponse,
  /**
   * @param {!proto.questionbank.ListQuestionnaireTemplateSectionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.ListQuestionnaireTemplateSectionsResponse.deserializeBinary
);


/**
 * @param {!proto.questionbank.ListQuestionnaireTemplateSectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.ListQuestionnaireTemplateSectionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.ListQuestionnaireTemplateSectionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.listQuestionnaireTemplateSections =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionnaireTemplateSections',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionnaireTemplateSections,
      callback);
};


/**
 * @param {!proto.questionbank.ListQuestionnaireTemplateSectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.ListQuestionnaireTemplateSectionsResponse>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.listQuestionnaireTemplateSections =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionnaireTemplateSections',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionnaireTemplateSections);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.ListQuestionnaireTemplateQuestionsRequest,
 *   !proto.questionbank.ListQuestionnaireTemplateQuestionsResponse>}
 */
const methodDescriptor_QuestionBankService_ListQuestionnaireTemplateQuestions = new grpc.web.MethodDescriptor(
  '/questionbank.QuestionBankService/ListQuestionnaireTemplateQuestions',
  grpc.web.MethodType.UNARY,
  proto.questionbank.ListQuestionnaireTemplateQuestionsRequest,
  proto.questionbank.ListQuestionnaireTemplateQuestionsResponse,
  /**
   * @param {!proto.questionbank.ListQuestionnaireTemplateQuestionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.ListQuestionnaireTemplateQuestionsResponse.deserializeBinary
);


/**
 * @param {!proto.questionbank.ListQuestionnaireTemplateQuestionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.ListQuestionnaireTemplateQuestionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.ListQuestionnaireTemplateQuestionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.QuestionBankServiceClient.prototype.listQuestionnaireTemplateQuestions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionnaireTemplateQuestions',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionnaireTemplateQuestions,
      callback);
};


/**
 * @param {!proto.questionbank.ListQuestionnaireTemplateQuestionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.ListQuestionnaireTemplateQuestionsResponse>}
 *     Promise that resolves to the response
 */
proto.questionbank.QuestionBankServicePromiseClient.prototype.listQuestionnaireTemplateQuestions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.QuestionBankService/ListQuestionnaireTemplateQuestions',
      request,
      metadata || {},
      methodDescriptor_QuestionBankService_ListQuestionnaireTemplateQuestions);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.questionbank.AssessmentServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.questionbank.AssessmentServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.CreateAssessmentFromTemplateRequest,
 *   !proto.questionbank.Assessment>}
 */
const methodDescriptor_AssessmentService_CreateAssessmentFromTemplate = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/CreateAssessmentFromTemplate',
  grpc.web.MethodType.UNARY,
  proto.questionbank.CreateAssessmentFromTemplateRequest,
  proto.questionbank.Assessment,
  /**
   * @param {!proto.questionbank.CreateAssessmentFromTemplateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Assessment.deserializeBinary
);


/**
 * @param {!proto.questionbank.CreateAssessmentFromTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Assessment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Assessment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.createAssessmentFromTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/CreateAssessmentFromTemplate',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_CreateAssessmentFromTemplate,
      callback);
};


/**
 * @param {!proto.questionbank.CreateAssessmentFromTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Assessment>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.createAssessmentFromTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/CreateAssessmentFromTemplate',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_CreateAssessmentFromTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.GetAssessmentRequest,
 *   !proto.questionbank.Assessment>}
 */
const methodDescriptor_AssessmentService_GetAssessment = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/GetAssessment',
  grpc.web.MethodType.UNARY,
  proto.questionbank.GetAssessmentRequest,
  proto.questionbank.Assessment,
  /**
   * @param {!proto.questionbank.GetAssessmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Assessment.deserializeBinary
);


/**
 * @param {!proto.questionbank.GetAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Assessment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Assessment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.getAssessment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/GetAssessment',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_GetAssessment,
      callback);
};


/**
 * @param {!proto.questionbank.GetAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Assessment>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.getAssessment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/GetAssessment',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_GetAssessment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.ListAssessmentsRequest,
 *   !proto.questionbank.ListAssessmentsResponse>}
 */
const methodDescriptor_AssessmentService_ListAssessments = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/ListAssessments',
  grpc.web.MethodType.UNARY,
  proto.questionbank.ListAssessmentsRequest,
  proto.questionbank.ListAssessmentsResponse,
  /**
   * @param {!proto.questionbank.ListAssessmentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.ListAssessmentsResponse.deserializeBinary
);


/**
 * @param {!proto.questionbank.ListAssessmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.ListAssessmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.ListAssessmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.listAssessments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/ListAssessments',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_ListAssessments,
      callback);
};


/**
 * @param {!proto.questionbank.ListAssessmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.ListAssessmentsResponse>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.listAssessments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/ListAssessments',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_ListAssessments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.DeleteAssessmentRequest,
 *   !proto.questionbank.Empty>}
 */
const methodDescriptor_AssessmentService_DeleteAssessment = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/DeleteAssessment',
  grpc.web.MethodType.UNARY,
  proto.questionbank.DeleteAssessmentRequest,
  proto.questionbank.Empty,
  /**
   * @param {!proto.questionbank.DeleteAssessmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Empty.deserializeBinary
);


/**
 * @param {!proto.questionbank.DeleteAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.deleteAssessment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/DeleteAssessment',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_DeleteAssessment,
      callback);
};


/**
 * @param {!proto.questionbank.DeleteAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Empty>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.deleteAssessment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/DeleteAssessment',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_DeleteAssessment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.AddAssessmentQuestionsRequest,
 *   !proto.questionbank.AddAssessmentQuestionsResponse>}
 */
const methodDescriptor_AssessmentService_AddAssessmentQuestions = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/AddAssessmentQuestions',
  grpc.web.MethodType.UNARY,
  proto.questionbank.AddAssessmentQuestionsRequest,
  proto.questionbank.AddAssessmentQuestionsResponse,
  /**
   * @param {!proto.questionbank.AddAssessmentQuestionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.AddAssessmentQuestionsResponse.deserializeBinary
);


/**
 * @param {!proto.questionbank.AddAssessmentQuestionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.AddAssessmentQuestionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.AddAssessmentQuestionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.addAssessmentQuestions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/AddAssessmentQuestions',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_AddAssessmentQuestions,
      callback);
};


/**
 * @param {!proto.questionbank.AddAssessmentQuestionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.AddAssessmentQuestionsResponse>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.addAssessmentQuestions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/AddAssessmentQuestions',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_AddAssessmentQuestions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.RemoveAssessmentQuestionRequest,
 *   !proto.questionbank.Empty>}
 */
const methodDescriptor_AssessmentService_RemoveAssessmentQuestion = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/RemoveAssessmentQuestion',
  grpc.web.MethodType.UNARY,
  proto.questionbank.RemoveAssessmentQuestionRequest,
  proto.questionbank.Empty,
  /**
   * @param {!proto.questionbank.RemoveAssessmentQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Empty.deserializeBinary
);


/**
 * @param {!proto.questionbank.RemoveAssessmentQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.removeAssessmentQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/RemoveAssessmentQuestion',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_RemoveAssessmentQuestion,
      callback);
};


/**
 * @param {!proto.questionbank.RemoveAssessmentQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Empty>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.removeAssessmentQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/RemoveAssessmentQuestion',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_RemoveAssessmentQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.UpdateAssessmentQuestionRequest,
 *   !proto.questionbank.AssessmentQuestion>}
 */
const methodDescriptor_AssessmentService_UpdateAssessmentQuestion = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/UpdateAssessmentQuestion',
  grpc.web.MethodType.UNARY,
  proto.questionbank.UpdateAssessmentQuestionRequest,
  proto.questionbank.AssessmentQuestion,
  /**
   * @param {!proto.questionbank.UpdateAssessmentQuestionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.AssessmentQuestion.deserializeBinary
);


/**
 * @param {!proto.questionbank.UpdateAssessmentQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.AssessmentQuestion)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.AssessmentQuestion>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.updateAssessmentQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/UpdateAssessmentQuestion',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_UpdateAssessmentQuestion,
      callback);
};


/**
 * @param {!proto.questionbank.UpdateAssessmentQuestionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.AssessmentQuestion>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.updateAssessmentQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/UpdateAssessmentQuestion',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_UpdateAssessmentQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.CreateAssessmentGatingRuleRequest,
 *   !proto.questionbank.AssessmentGatingRule>}
 */
const methodDescriptor_AssessmentService_CreateAssessmentGatingRule = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/CreateAssessmentGatingRule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.CreateAssessmentGatingRuleRequest,
  proto.questionbank.AssessmentGatingRule,
  /**
   * @param {!proto.questionbank.CreateAssessmentGatingRuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.AssessmentGatingRule.deserializeBinary
);


/**
 * @param {!proto.questionbank.CreateAssessmentGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.AssessmentGatingRule)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.AssessmentGatingRule>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.createAssessmentGatingRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/CreateAssessmentGatingRule',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_CreateAssessmentGatingRule,
      callback);
};


/**
 * @param {!proto.questionbank.CreateAssessmentGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.AssessmentGatingRule>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.createAssessmentGatingRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/CreateAssessmentGatingRule',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_CreateAssessmentGatingRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.UpdateAssessmentGatingRuleRequest,
 *   !proto.questionbank.AssessmentGatingRule>}
 */
const methodDescriptor_AssessmentService_UpdateAssessmentGatingRule = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/UpdateAssessmentGatingRule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.UpdateAssessmentGatingRuleRequest,
  proto.questionbank.AssessmentGatingRule,
  /**
   * @param {!proto.questionbank.UpdateAssessmentGatingRuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.AssessmentGatingRule.deserializeBinary
);


/**
 * @param {!proto.questionbank.UpdateAssessmentGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.AssessmentGatingRule)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.AssessmentGatingRule>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.updateAssessmentGatingRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/UpdateAssessmentGatingRule',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_UpdateAssessmentGatingRule,
      callback);
};


/**
 * @param {!proto.questionbank.UpdateAssessmentGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.AssessmentGatingRule>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.updateAssessmentGatingRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/UpdateAssessmentGatingRule',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_UpdateAssessmentGatingRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.questionbank.DeleteAssessmentGatingRuleRequest,
 *   !proto.questionbank.Empty>}
 */
const methodDescriptor_AssessmentService_DeleteAssessmentGatingRule = new grpc.web.MethodDescriptor(
  '/questionbank.AssessmentService/DeleteAssessmentGatingRule',
  grpc.web.MethodType.UNARY,
  proto.questionbank.DeleteAssessmentGatingRuleRequest,
  proto.questionbank.Empty,
  /**
   * @param {!proto.questionbank.DeleteAssessmentGatingRuleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.questionbank.Empty.deserializeBinary
);


/**
 * @param {!proto.questionbank.DeleteAssessmentGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.questionbank.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.questionbank.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.questionbank.AssessmentServiceClient.prototype.deleteAssessmentGatingRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/questionbank.AssessmentService/DeleteAssessmentGatingRule',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_DeleteAssessmentGatingRule,
      callback);
};


/**
 * @param {!proto.questionbank.DeleteAssessmentGatingRuleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.questionbank.Empty>}
 *     Promise that resolves to the response
 */
proto.questionbank.AssessmentServicePromiseClient.prototype.deleteAssessmentGatingRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/questionbank.AssessmentService/DeleteAssessmentGatingRule',
      request,
      metadata || {},
      methodDescriptor_AssessmentService_DeleteAssessmentGatingRule);
};


module.exports = proto.questionbank;

